import { Type } from "@sinclair/typebox";
import { siteReferenceSetSchema } from "./site-reference.js";
const text = Type.String({ minLength: 1 });
/** A source mean height belongs to the unchanged historical UVL, never the selected outline. */
export const historicalReferenceHeightSchema = Type.Object({
    unitId: text,
    sourceUnitId: text,
    sourceBuildingId: text,
    heightM: Type.Number({ exclusiveMinimum: 0 }),
    heightMeaning: Type.Literal("source_mean_height"),
    source: Type.Object({
        name: text,
        reference: Type.Union([text, Type.Null()]),
        observedAt: Type.Union([text, Type.Null()]),
        releaseKey: text
    }, { additionalProperties: false }),
    association: Type.Literal("spatial_overlap"),
    sharedWithPartIds: Type.Array(text)
}, { additionalProperties: false });
export const siteReferenceSetV2Schema = Type.Object({
    ...siteReferenceSetSchema.properties,
    version: Type.Literal("operational-reference-set/v2"),
    selectableParts: Type.Array(Type.Union(["body", "context"].map((role) => Type.Object({
        id: text,
        label: text,
        outlineBodyId: text,
        outlineRole: Type.Literal(role),
        observationIds: Type.Array(text),
        historicalHeights: Type.Array(historicalReferenceHeightSchema, role === "context" ? { maxItems: 0 } : {})
    }, { additionalProperties: false }))), { minItems: 1, maxItems: 10 })
}, { additionalProperties: false });
//# sourceMappingURL=site-reference-v2.js.map